import Bits from '../../../bits';
import Modules from '../../../modules';
import Wrappers from '../../../wrappers';


class SectionController {

	constructor() {
		this.bits = Bits;
		this.modules = Modules;
		this.wrappers = Wrappers;

		this.active = {};

		this.globals = {};
	}

	initialize(index, scope = document) {
		for (const type of ['bits', 'modules', 'wrappers']) {
			for (const selector in this[type]) {
				const els = scope.querySelectorAll(`.${selector}`);
				for (const el of els) {
					if (!this.active[index]) this.active[index] = [];
					this.active[index].push(new this[type][selector].Class(el));
				}
			}
		}
	}

	initializeGlobal(els) {
		for (const path in els) {
			const [type, selector] = path.split('/');
			this.globals[selector] = new this[type][selector].Class(els[path]);
		}
	}

	destroy(index) {
		for (const m of this.active[index]) {
			if (m.destroy) {
				m.destroy();
			} else {
				console.error(m, 'Missing [destroy] function!'); // eslint-disable-line no-console
			}
		}
		delete this.active[index];
	}

}

export default new SectionController();
